
import React, { useState, useEffect } from 'react'
import "./PaginaSobras.css"
import Loading from "../../componentes/Loading/Loading";
import TabelaAnosSobras from './TabelaAnosSobras';

const PaginaImportar = () => {


    const [loading, setLoading] = useState(false);
    const [anosSobras, setAnosSobras] = useState([])
    const [anoSobra, setAnoSobra] = useState(0);
    const [pdfSobras, setPdfSobras] = useState({})
    const [error, setError] = useState({})


    useEffect(() => {
        setAnosSobras({});
        buscarAnosSobra();
    }, []);
    async function buscarAnosSobra() {
        setLoading(true);
         const endPoint = `/api/listar-anos-sobras`;
        const headers = new Headers({
            'Accept': 'application/json',
            'Authorization': `Bearer ${getUrlParamByName("token")}`
        });
        const options = {
            method: "GET",
            headers: headers
        };
        fetch(endPoint, options)
            .then(resposta => resposta.json())
            .then(json => {
                setLoading(false);
                setAnosSobras(json);
            })
            .catch(error => {
                setLoading(false);
                setError(error.message);
                console.log(error);
                alert('Não foi possível carregar a listagem dos anos em que houve Rateio Sobras');
            })
    }



    useEffect(() => {
        setPdfSobras({});
        if (anoSobra > 0) {
            buscarPdfSobra();
        }

    }, [anoSobra]);
    async function buscarPdfSobra() {
        setLoading(true);
        const endPoint = `/api/gerar-pdf-sobras?ano=${anoSobra}`;
        fetch(endPoint, {
            method: 'get',
            headers: new Headers({
                'Accept': 'application/json',
                'Authorization': `Bearer ${getUrlParamByName("token")}`
            })
        })
            .then(resposta => resposta.json())
            .then(json => {
                setLoading(false);
                downLoadFile(json.conteudoBase64, json.nome, "openNewTab");
                setAnoSobra(0);
            })
            .catch(error => {
                setLoading(false);
                console.log(error);
                alert('Não foi possível carregar o PDF referente aos dados de Sobras para o ano selecionado');
            })
    }

    function getUrlParamByName(name, url) {
        if (!url)
            url = document.URL;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    function downLoadFile(conteudoBase64, nameArq, opcao) {
        console.log("Executando Download Arquivo:" + nameArq)
        const bufferArray = base64ToArrayBuffer(conteudoBase64);
        let blob = new Blob([bufferArray], { type: 'application/pdf' });
        let url = window.URL.createObjectURL(blob);
        if (opcao == "openNewTab") {
            var newWindow = window.open(url, '_blank');
            setTimeout(function () { newWindow.document.title = nameArq; }, 3000);
        } else {
            let a = document.createElement('a');
            a.href = url;
            a.download = nameArq;
            a.click();
        }
    }

    function base64ToArrayBuffer(conteudoBase64) {
        const bString = window.atob(conteudoBase64);
        const bLength = bString.length;
        const bytes = new Uint8Array(bLength);
        for (let i = 0; i < bLength; i++) {
            bytes[i] = bString.charCodeAt(i);
        }
        return bytes;
    }


    return (
        <section >
            <div className="pagina-sobras">
                <div className="tituloPagina col-md-12 col-xs-12">
                     <span >Abaixo segue o Rateio de Sobras do cooperado.</span>
                </div>
                <div className="col-md-12 col-xs-12">
                    {(anosSobras && anosSobras.length > 0) && <span>Selecione abaixo uma competência:</span>}
                </div>
                {/* <div  className="col-md-12 col-xs-12 d-flex align-items-center justify-content-center"> */}
                <div  className="col-md-12 col-xs-12">
                    {(anosSobras && anosSobras.length > 0) && <TabelaAnosSobras anosSobras={anosSobras} anoSobra={anoSobra} setAnoSobra={setAnoSobra} />}
                </div>
                {loading && <Loading />}
            </div >
        </section >
    );
}
export default PaginaImportar;
